export default "__VITE_ASSET__3e48b289__"